import { Places, ParamIds } from '../../Constants'
import { MainKeys } from '../../main/Main.keys'
import { TheConsumerMarketPresenter } from './tcm_presenter'

const filterPaneUUID = '9f2a16d3df2f'

export class TheConsumerMarketKeys extends MainKeys {
    get place() {
        return Places.theConsumerMarket
    }

    get selectedListingTab() {
        return this._intent.getParameterAsString(ParamIds.tmListingTab)
    }

    set selectedListingTab(value: string | undefined) {
        if (value && value !== 'none') {
            this._intent.setParameter(ParamIds.tmListingTab, value)
        } else {
            this._intent.setParameter(ParamIds.tmListingTab, undefined)
        }
    }

    get tcmPresenter() {
        return this._intent.attributes.get(filterPaneUUID) as TheConsumerMarketPresenter
    }

    set tcmPresenter(value: TheConsumerMarketPresenter) {
        this._intent.attributes.set(filterPaneUUID, value)
    }
}
